import { memo, MouseEventHandler, useCallback } from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

export type PopoverOption = {
  label: string;
  icon?: React.FC;
  className?: string;
};

type Props = {
  option: PopoverOption;
  onClick: (option: PopoverOption) => void;
};

export const PopoverItem: React.FC<Props> = memo(function PopoverItem({ option, onClick }) {
  const handleClick: MouseEventHandler<HTMLDivElement> = useCallback(
    (event) => {
      event.stopPropagation();
      onClick(option);
    },
    [onClick, option],
  );

  return (
    <div className={classNames(styles.container, option.className)} onClick={handleClick}>
      {option.icon && <option.icon />}
      <p>{option.label}</p>
    </div>
  );
});
